import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {

  private readonly permissionDeniedMessage = "You do not have the required permissions to view this patient's information.";
  private readonly permissionToastCooldownMs = environment.permissionToastCooldownMs;
  private lastPermissionToastAt = 0;

  constructor(private readonly toastr: ToastrService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 403) {

          if (request.method === 'GET' && request.url.toLowerCase().includes('/api/patient/search')) {
            return of(new HttpResponse({ body: [], status: 200, url: error.url || request.url }));
          }

          this.showPermissionDeniedToast();
          return throwError(() => new HttpErrorResponse({
            error: this.permissionDeniedMessage,
            headers: error.headers,
            status: 403,
            statusText: error.statusText,
            url: error.url || request.url
          }));
        }

        return throwError(() => error);
      })
    );
  }

  private showPermissionDeniedToast(): void {
    const now = Date.now();
    if (now - this.lastPermissionToastAt < Number(this.permissionToastCooldownMs)) {
      return;
    }

    this.lastPermissionToastAt = now;
    const toastOptions = {
      positionClass: 'toast-top-center',
      toastClass: 'ngx-toastr toast-center-custom',
      timeOut: Number(this.permissionToastCooldownMs)
    };

    this.toastr.error(this.permissionDeniedMessage, 'Permission Denied', toastOptions);

    setTimeout(() => {
      const toastElement = document.querySelector('.toast-center-custom') as HTMLElement;
      if (toastElement) {
        toastElement.style.width = '550px';
        toastElement.style.marginTop = '57px';
      }
    }, 10);
  }
}
